import { getApiBaseUrl } from '../config/apiBaseUrl';

const STORE_CACHE_KEY = 'providerStoreInfo';

export async function getStoreInfo(accessToken) {
  const response = await fetch(`${getApiBaseUrl()}/api/provider/store`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || `HTTP error! status: ${response.status}`);
  }
  return data.store || null;
}

export function cacheStoreInfo(store) {
  if (!store) return;
  try {
    sessionStorage.setItem(STORE_CACHE_KEY, JSON.stringify(store));
  } catch (e) {
    // Storage unavailable (private mode) — the UI just falls back gracefully.
  }
}

export function getCachedStoreInfo() {
  try {
    const raw = sessionStorage.getItem(STORE_CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}
